// Copyright (c) 2017-present Mattermost, Inc. All Rights Reserved.
// See License.txt for license information.

import plugins from './plugins';
import views from './views';

export default {
    views,
    plugins
};



// WEBPACK FOOTER //
// ./reducers/index.js